export default __webpack_public_path__ + "static/media/running-solid.24f44c8f.svg";